/*
 * Directive that sets the 'slider-value' attribute of a ui-slider to the current value of the slider
 * The slider-value attribute is then used by a CSS pseudo element to output the value relative to the 
 * slider's handle on screen.
 */

angular.module('qkr').directive('mcUiSliderValueOutput', function() {
    return {
    	require: 'ngModel',
        restrict: 'A',
        scope: {
            model: '=ngModel'
        },
        transclude: true,
        link(scope, element, attrs, ngModel) {
	        scope.$watch('model', (val) => {
	        	const children = element.children();
	        	
	        	angular.forEach(children, (child) => {
	        		if (angular.element(child).hasClass('ui-slider-handle')) {
	        			angular.element(child).attr('slider-value', val);
	        		}
	        	});
	        });
        }
    };
});



// WEBPACK FOOTER //
// ./src/directives/ui-slider-value-output.js